import React from "react";
import { KPI_LIST } from "../constants/kpi";

const STORAGE_KEY = "kpiCards.visible.v1";

interface Props {
    visible: Record<string, boolean>;
    onChange: (next: Record<string, boolean>) => void;
}

export const KpiVisibilitySettings: React.FC<Props> = ({
    visible,
    onChange,
}) => {
    const toggle = (key: string) => {
        const next = { ...visible, [key]: !visible[key] };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        onChange(next);
    };

    return (
        <details className="border rounded-md bg-white px-3 py-2 shadow-sm">
            <summary className="cursor-pointer text-sm text-blue-600">
                KPI 表示設定
            </summary>

            <div className="mt-2 flex flex-wrap gap-3">
                {KPI_LIST.map((k) => (
                    <label
                        key={k.key}
                        className="flex items-center gap-1 text-xs border px-2 py-1 rounded bg-slate-50"
                    >
                        <input
                            type="checkbox"
                            checked={visible[k.key] ?? true}
                            onChange={() => toggle(k.key)}
                        />
                        {k.title}
                    </label>
                ))}
            </div>
        </details>
    );
};
